export default "__VITE_ASSET__affd20eb__"